import React, { useContext, useEffect, useState } from "react";
import 'bootstrap-icons/font/bootstrap-icons.css';
import "./ClienteMaquinas.css";
import { Button, Col, Row } from "antd";
import axios from "axios";
import * as links from "../../../../utils/links";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Link, useNavigate, useLocation } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faArrowsRotate,
  faCheckCircle,
  faWifi3,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { AiFillBook, AiOutlineCodeSandbox, AiOutlineEdit, AiOutlinePlusCircle, AiOutlineQrcode } from "react-icons/ai";
import { useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ClienteMaquinas = (props) => {
  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;

  let navigate = useNavigate();
  const location = useLocation();

  const clienteInfo = location.state;

  const token = authInfo?.dataUser?.token;

  const { id } = useParams();

  const [totalClienteMaquinas, setTotalClienteMaquinas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dataData();

    const intervalId = setInterval(() => {
      dataData();
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const dataData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_SERVIDOR}/maquinas-adm?id=${id}`, {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setTotalClienteMaquinas(res.data);
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          if(dataUser.key === 'ADMIN'){
            navigate(links.ADMIN_SIGNIN)
            setDataUser(null);
          }else{
            navigate(links.SIGNIN)
            setDataUser(null);
          }
        }
      });
  };

  return (
    <div className="Cliente_Maquinas_container">
      {isLoading && <LoadingAction />}
      <div className="WarningMsgSpan">
        <span>{dataUser.warningMsg}</span>
      </div>
      <div className="AddCliente_header">
        <div className="AddCliente_header_title">Dispositivos do cliente:</div>
        <Link className="AddCliente_header_back" to={links.DASHBOARD_CLIENTES}>
          VOLTAR
        </Link>
      </div>
      <div className="Cliente_Maquinas_header">
        <div className="Cliente_Maquinas_staBlockTitle">{clienteInfo.nome}</div>
      </div>
      <div className="Cliente_Maquinas_action">
        <Button style={{ marginLeft: "15px", marginTop: '10px' }}>
          <FontAwesomeIcon
            icon={faArrowsRotate}
            style={{ marginRight: "5px" }}
          />
          Atualizar
        </Button>

        <Button
          style={{ marginLeft: "15px", marginTop: '10px' }}
          className="Cliente_Maquinas_addbtn"
          onClick={() =>
            navigate(`${links.ADD_CLIENTES_MAQUINA_ADM}/${clienteInfo.id}`, {
              state: location.state,
            })
          }
        >
          <AiOutlinePlusCircle />
          <span>Adicionar Máquina</span>
        </Button>

        <div style={{ marginLeft: "15px", marginTop: '10px' }}>
          <Button
            className="Cliente_Maquinas_editbtn"
            onClick={() =>
              navigate(`${links.EDITAR_CLIENTES}/${clienteInfo.id}`, {
                state: clienteInfo,
              })
            }
          >
            <AiOutlineEdit />
            <span>Editar Cliente</span>
          </Button>
        </div>
        <div style={{ marginLeft: "15px", marginTop: '10px' }}>
          <Button
            className="Cliente_Maquinas_editbtn"
            onClick={() =>
              navigate(`${links.CLIENTE_MENSALIDADES_ADM}/${clienteInfo.id}`, {
                state: clienteInfo,
              })
            }
          >
            <AiOutlineQrcode/>
            <span>Mensalidades</span>
          </Button>
        </div>
      </div>
      <Row>
        {totalClienteMaquinas?.map((post, index) => (
          <Col key={index} xs={24} md={24} lg={8} xl={8} className="Cliente_Maquinas_col">
            <div
              onClick={() =>
                navigate(
                  `${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/${post.id}`,
                  {
                    state: { clienteInfo, maquinaInfos: post },
                  }
                )
              }
            >
              <div className="maquina" key={post.id} onClick={() => null}>
                <div className="maquina-info">
                  {(() => {
                    switch (post.status) {
                      case "ONLINE":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faCheckCircle}
                              color={"green"}
                              className="logout-icon fa-3x"
                            />
                            {
                              post.nivelDeSinal ?
                              post.nivelDeSinal <= 30 ? 
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-1" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              post?.nivelDeSinal <= 60 ?
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                  <i className="bi bi-reception-2" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              post?.nivelDeSinal <= 70 ?
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-3" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                <i className="bi bi-reception-4" style={{ fontSize: '42px', color: 'blue' }}></i>
                              </OverlayTrigger>
                              :
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                  <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent'}}></i>
                              </OverlayTrigger>
                            }
                          </div>
                        );
                      case "OFFLINE":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FontAwesomeIcon
                              icon={faXmarkCircle}
                              color={"red"}
                              className="logout-icon fa-3x"
                            />
                            {
                              <OverlayTrigger
                                key={post.id}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                  </Tooltip>
                                }>
                                  <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent'}}></i>
                              </OverlayTrigger>
                            }
                          </div>
                        );
                      case "PAGAMENTO_RECENTE":
                        return (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            color={"blue"}
                            className="logout-icon fa-3x"
                          />
                          {
                            post.nivelDeSinal ?
                            post.nivelDeSinal <= 30 ? 
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                    {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-1" style={{ fontSize: '42px', color: 'blue' }}></i>
                            </OverlayTrigger>
                            :
                            post?.nivelDeSinal <= 60 ?
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-2" style={{ fontSize: '42px', color: 'blue' }}></i>
                            </OverlayTrigger>
                            :
                            post?.nivelDeSinal <= 70 ?
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-3" style={{ fontSize: '42px', color: 'blue' }}></i>
                            </OverlayTrigger>
                            :
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-4" style={{ fontSize: '42px', color: 'blue' }}></i>
                            </OverlayTrigger>
                            :
                            <OverlayTrigger
                              key={post.id}
                              placement="top"
                              overlay={
                                <Tooltip id={`tooltip-top-${post.id}`}>
                                  {post?.nivelDeSinal ? `${post.nivelDeSinal}%` : '0%'}
                                </Tooltip>
                              }>
                                <i className="bi bi-reception-0" style={{ fontSize: '42px', color: 'transparent'}}></i>
                            </OverlayTrigger>
                          }
                        </div>
                        );
                      default:
                        return null;
                    }
                  })()}

                  <h2>{post.nome}</h2>
                  <h6 style={{ fontWeight: "300" }}>
                    {post.status} - {post.descricao}
                  </h6>
                  <h6 style={{ fontWeight: "300" }}>MP: {post.store_id}</h6>
                  <h6 style={{ fontWeight: "300" }}>PAG: {post.maquininha_serial}</h6>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ClienteMaquinas;
